"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.resizeImage = void 0;
var resizeImage = function resizeImage(url) {
  var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 768;
  var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'auto';
  var config = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  if (!url.includes('images.contentstack.io')) return url;
  var _config$crop = config.crop,
    crop = _config$crop === void 0 ? true : _config$crop,
    _config$quality = config.quality,
    quality = _config$quality === void 0 ? 80 : _config$quality,
    _config$overlay = config.overlay,
    overlay = _config$overlay === void 0 ? null : _config$overlay,
    disableSmartCrop = config.disableSmartCrop;
  var defaultTransforms = "?auto=webp&format=pjpg&quality=".concat(quality);
  var paramOverlay = overlay ? "&overlay=".concat(overlay, "&overlay-repeat=both") : '';
  var paramFit = height !== 'auto' ? "&fit=".concat(crop ? 'crop' : 'bounds') : '';
  if (disableSmartCrop || height === 'auto' || width === 'auto') {
    var _paramWidth = "&width=".concat(width);
    var _paramHeight = "&height=".concat(height);
    return "".concat(url).concat(defaultTransforms).concat(_paramWidth).concat(_paramHeight).concat(paramFit).concat(paramOverlay);
  }
  var size = width > height ? width : height;
  var paramWidth = "&width=".concat(size);
  var paramHeight = "&height=".concat(size);
  var paramCrop = "&crop=".concat(width, ":").concat(height, ",smart");
  return "".concat(url).concat(defaultTransforms).concat(paramWidth).concat(paramHeight).concat(paramFit).concat(paramOverlay).concat(paramCrop);
};
exports.resizeImage = resizeImage;
var _default = resizeImage;
exports.default = _default;